import {ChangeEvent, ReactNode} from 'react';
import {ObjectOfAny} from '../../../types';

// this is somewhat duped from `types/index.ts` whilst we work out all of the typing

export type BaseField = {
  name: string;
  label: string;
  assistiveMessage?: ReactNode;
  placeholder?: string;
  required?: boolean;
  isDisabled?: boolean;
  warningMessage?: ReactNode;
  showOptionalMessage?: boolean;
  formikFieldName?: string;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
};

export type Field = BaseField & {
  errorMessage?: ReactNode;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export type FormikField = BaseField & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate?: (value: any) => void;
  errorMessages?: CustomErrorMessages;
  // @todo: remove opt in for custom errors
  useCustom?: boolean;
};

export type Option = {
  label: string;
  value: string;
};

export type FieldErrorMessage = string | ((values: ObjectOfAny) => string);

export interface CustomErrorMessages {
  required?: FieldErrorMessage;
  number?: FieldErrorMessage;
  minMaxNumber?: FieldErrorMessage;
  minNumber?: FieldErrorMessage;
  maxNumber?: FieldErrorMessage;
  date?: FieldErrorMessage;
  minMaxDate?: FieldErrorMessage;
  minDate?: FieldErrorMessage;
  maxDate?: FieldErrorMessage;
  email?: FieldErrorMessage;
  password?: FieldErrorMessage;
  phone?: FieldErrorMessage;
  legacy?: FieldErrorMessage;
}

export type DateLimits = {
  min?: Date;
  max?: Date;
};

export type QuoteFormDateLimits = Required<DateLimits>;

export enum ValidDateType {
  MIN = 'min',
  MAX = 'max',
  RANGE = 'range',
}

export type ValidDate = {
  isValid: boolean;
  type?: ValidDateType;
};
